import React from "react";
import { NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const projects = [
  {
    image: require("../../images/projects/galleries/image1.jpg"),
  },
  {
    image: require("../../images/projects/galleries/image2.jpg"),
  },
  {
    image: require("../../images/projects/galleries/image3.jpg"),
  },
  {
    image: require("../../images/projects/galleries/image4.jpg"),
  },
  {
    image: require("../../images/projects/galleries/image5.jpeg"),
  },
  {
    image: require("../../images/projects/galleries/image6.jpg"),
  },
];

class Projects6 extends React.Component {
  render() {
    const options = {
      loop: false,
      autoplay: false,
      margin: 0,
      nav: true,
      dots: false,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        540: {
          items: 2,
        },
        768: {
          items: 3,
        },
        991: {
          items: 3,
        },
        1136: {
          items: 4,
        },
        1366: {
          items: 4,
        },
      },
    };
    return (
      <>
        <div className="section-full p-b20 mobile-page-padding">
          <div className="filter-carousal-1 relative z-index1 ">
            <div className="section-content">
              {/* TITLE START */}
              <div className="section-head">
                <div className="sx-separator-outer separator-left">
                  <div
                    className="sx-separator bg-white bg-moving bg-repeat-x"
                    //  style={{ backgroundImage: 'url(' + bgimg1 + ')' }}
                  >
                    <h3 className="sep-line-one">Galerie Photos</h3>
                  </div>
                </div>
              </div>
              {/* TITLE END */}
              <div className="work-carousel-outer">
                <OwlCarousel
                  className="owl-carousel mfp-gallery project-carousel project-carousel3 owl-btn-vertical-center p-lr80"
                  {...options}
                >
                  {projects.map((item, index) => (
                    <div key={index} className={`item fadingcol overflow-hide`}>
                      <div className="sx-box   image-hover-block">
                        <div className="sx-thum-bx">
                          <img src={item.image} alt="" />
                        </div>

                        <a className="mfp-link" href={item.image}>
                          <i className="fa fa-arrows-alt" />
                        </a>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Projects6;
